export const ENTITY_STATUS_NONE = 0;
export const ENTITY_STATUS_INWORKS = 1;
export const ENTITY_STATUS_PUBLISHED = 2;
export const ENTITY_STATUS_ARCHIVED = 3;

export const ENTITY_FIELD_STATUS_INWORKS = 1;
export const ENTITY_FIELD_STATUS_PUBLISHED = 2;

export const ENTITY_RELEASE_TYPE_PILGRIM = 'PILGRIM';
export const ENTITY_RELEASE_TYPE_CUSTOM = 'CUSTOM';

export const TAB_FIELDS_INDEX = 0;
export const TAB_RELATIONS_INDEX = 1;
export const TAB_RESOLVED_FIELDS_INDEX = 2;

export const ENTITY_INFO_DISABLED_PROPERTIES = ['EntityName', 'EntityViewName', 'ObjectTable'];

export const RELATION_TYPES = [
  {
    value: '1to1',
    label: '1-to-1',
  },
  {
    value: '1TO1DYNAMICENTITY',
    label: '1-to-1 (Dynamic)',
  },
  {
    value: '1toMany',
    label: '1-to-Many',
  },
  {
    value: '1TOMANYDYNAMICENTITY',
    label: '1-to-Many (Dynamic)',
  },
  {
    value: '1TOMANYDEFERCONTENTROCESSING',
    label: '1-to-Many (High Volume)',
  },
  {
    value: 'NONPERSISTENT',
    label: 'Non Persistent',
  },
];

export const TABLE_FIELDS_CONTROL_TYPE = 1;
export const TABLE_RELATIONS_CONTROL_TYPE = 2;
export const TABLE_RESOLVED_FIELDS_CONTROL_TYPE = 3;

export const DEFAULT_FIELD_TYPE = 'UNDEFINED';

export const FIELDS_FIELD_NAME = 'FieldName';
export const FIELDS_LABEL = 'Label';
export const FIELDS_RESOLVER_TYPE = 'ResolverType';
export const FIELDS_FIELD_TYPE = 'TypeId';
export const FIELDS_IS_USABLE = 'IsUsable';
export const FIELDS_IS_USER_KEY = 'IsUserKey';
export const FIELDS_IS_REQUIRED = 'IsRequired';
export const FIELDS_IS_EVENT_ENABLED = 'IsEventEnabled';
export const FIELDS_IS_PART_OF_AI_SEARCH = 'IsPartOfAISearch';
export const FIELDS_IS_COMPUTED = 'IsComputed';
export const FIELDS_COMPUTED_FORMULA = 'ComputedFormula';
export const FIELDS_VALIDATE_AGAINST_LABEL = 'ValidateAgainstLabel';
export const FIELDS_STATUS_LABEL = 'StatusLabel';
export const FIELDS_FIELD_TYPE_LABEL = 'TypeLabel';

export const RELATIONS_CHILD_ENTITY_NAME = 'Id';
export const RELATIONS_RELATION_TYPE = 'RelationType';
export const RELATIONS_PARENT_OBJECT_KEY = 'ParentObjectKey';
export const RELATIONS_PARENT_TABLE_OBJECT_KEY_COLUMN = 'ParentTableObjectKeyColumn';
export const RELATIONS_SUB_ENTITY_ID = 'SubEntityId';
export const RELATIONS_RELATION_TYPE_LABEL = 'RelationTypeLabel';

export const RESOLVED_FIELDS_SOURCE = 'source';
export const RESOLVED_FIELDS_TARGET = 'target';
export const RESOLVED_FIELDS_TARGET_NAME = 'targetFieldName';
export const RESOLVED_FIELDS_SOURCE_ITEMS = 'selectedFieldSetFields';
export const RESOLVED_FIELDS_TARGET_ITEMS = 'targetListItems';

export const ENTITY_TYPE_PARENT = 'parent';
export const ENTITY_TYPE_CHILD = 'child';
export const ENTITY_TYPE_MASTER_SETUP_PARENT = 'MasterSetupParent';
export const ENTITY_TYPE_MASTER_SETUP_CHILD = 'MasterSetupChild';

export const ENTITY_RUNTIME_TABLE = 'RuntimeTable';

export const ENTITY_VERSION_ONE = 1;

export const NON_EXISTENT_ENTITY_VERSION = 0;

export const ENTITY_TYPES = [
  { label: 'Parent', value: ENTITY_TYPE_PARENT },
  { label: 'Child', value: ENTITY_TYPE_CHILD },
  { label: 'Master Setup Parent', value: ENTITY_TYPE_MASTER_SETUP_PARENT },
  { label: 'Master Setup Child', value: ENTITY_TYPE_MASTER_SETUP_CHILD },
];

export const RUNTIME_TABLE_VALUES = {
  parent: ['GRC_RUN_GT1', 'GRC_RUN_GT2', 'GRC_RUN_GT3'],
  child: [
    'GC_RUN_GT1',
    'GC_RUN_GT2',
    'GC_RUN_GT3',
    'GC_RUN_GT4',
    'GC_RUN_GT5',
    'GC_RUN_GT6',
    'GC_RUN_GT7',
    'GC_RUN_GT8',
    'GC_RUN_GT9',
    'TXT_RUN_GT1',
  ],
  MasterSetupParent: ['MSP_RUN_GT1'],
  MasterSetupChild: ['MSC_RUN_GT1'],
};

export const VIEW_RIGHT = 'SSE_VIEW';
export const EDIT_RIGHT = 'SSE_EDIT';
export const CREATE_RIGHT = 'SSE_CREATE';
export const SPECIALIZED_RIGHT = 'SSE_SPECIALIZED';

export const HEADER_ITEM_DEFAULT_LABEL = '---';

export const RESOLVER_TYPE_LISTS = 'Lists';
